import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild  } from '@angular/core';
import { MatSelect } from '@angular/material';
import { Subscription } from 'rxjs';
import { EditUnitSatService } from '../../services/edit-unit-sat.service';
import { generalService } from '../../services/general.service';

@Component({
  selector: 'app-edit-unit-sat',
  templateUrl: './edit-unit-sat.component.html',
  styleUrls: [],
  providers: [generalService]
})
export class EditUnitSatComponent implements OnInit {
  public viewDataProduct2: any[];
  private arrayFilteredSatUnit = undefined;
  @Input() product : any ;
  @Input() enabled : boolean = false ;
  @Output() changeUnitSAT : EventEmitter<any> = new EventEmitter();
  ref: Subscription;
  private isFilteredSatUnit = false;
  private filteredItemsShowSat2 = 10;
  private itemsShow2 = 10;
  constructor(private _editUnitSatService : EditUnitSatService ) {
    this.ref = this._editUnitSatService.matOptions$.subscribe(data=>{
      //this.matOptions = data;
      this.moverSeleccionSATUnit();
    });
    if(this._editUnitSatService.matOptions.SATcodes != undefined){
      this._editUnitSatService.emitMatOptions();
    }

   }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges) {
    if(changes.product)
    {
       this.product = changes.product.currentValue;
       this.moverSeleccionSATUnit();
       
    }
 
  }
  moverSeleccionSATUnit() {
    /***************************INFINITE SELECT**********************************/

    if(this.product!= undefined && this._editUnitSatService.matOptions.SATunits != undefined)
    {
      const index = this._editUnitSatService.matOptions.SATunits.findIndex(x => x.itemSATUnitId == this.product.itemSATUnitId);
      var a = this._editUnitSatService.matOptions.SATunits.splice(index,1);
      this._editUnitSatService.matOptions.SATunits.unshift(a[0]);
    
      this.viewDataProduct2 = this._editUnitSatService.matOptions.SATunits.slice(0, 10);

    //   const index = this.matOptions.SATunits.findIndex(x => x.itemSATUnitId == this.product.itemSATUnitId);
    // var a = this.matOptions.SATunits.splice(index,1);
    // this.matOptions.SATunits.unshift(a[0]);
    
    // this.viewDataProduct2 = this.matOptions.SATunits.slice(0, 10);
    }
    
    /***************************INFINITE SELECT**********************************/
  }

  onKeyUpSATunit(val: any) {
    let arr2: any[];
    if (val.currentTarget.value != "") {
      this.arrayFilteredSatUnit = this._editUnitSatService.matOptions.SATunits.filter((obj) => {
        return obj.Name.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
      })

      arr2 = this.arrayFilteredSatUnit.slice(0, this.filteredItemsShowSat2);
      this.isFilteredSatUnit = true;
    } else {
      /***************************INFINITE SELECT**********************************/
      // arr = this.filtroSATCodes;
      this.isFilteredSatUnit = false;
      this.filteredItemsShowSat2 = 10;
      this.arrayFilteredSatUnit = undefined;
      arr2 = this._editUnitSatService.matOptions.SATunits.slice(0, this.itemsShow2);
      /***************************INFINITE SELECT**********************************/
    }
    /***************************INFINITE SELECT**********************************/
    //this.matOptions.SATcodes = arr;
    this.viewDataProduct2 = arr2;
    /***************************INFINITE SELECT**********************************/
  }

  emitNewUnitSAT(code:any){
    this.changeUnitSAT.emit([this.product.itemId,code.value]);
  }

  ngOnDestroy(): void {
    this.ref.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/product/edit-unit-sat/edit-unit-sat.component.ts